export default "__VITE_ASSET__BzplL3bg__"